export default __webpack_public_path__ + "static/media/Favicon-Light-20211230.aab62f3c.png";